// src/components/navigation/AuthStack.tsx
import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { AuthStackParamList } from "./navigationTypes";

import { OnboardingScreen } from "../screens/onboarding/OnboardingScreen";
import { LoginScreen } from "../screens/auth/LoginScreen";
import { RegisterScreen } from "../screens/auth/RegisterScreen";
import { ForgotMPINScreen } from "../screens/auth/ForgotMPINScreen";
import { VersionDetailsScreen } from "../screens/version/VersionDetailsScreen";

const Stack = createNativeStackNavigator<AuthStackParamList>();

export function AuthStack({ hasSeenOnboarding }: { hasSeenOnboarding: boolean }) {
  return (
    <Stack.Navigator
      screenOptions={{ headerShown: false }}
      initialRouteName={hasSeenOnboarding ? "Login" : "Onboarding"}
    >
      <Stack.Screen name="Onboarding" component={OnboardingScreen} />
      <Stack.Screen name="Login" component={LoginScreen} />
      <Stack.Screen name="Register" component={RegisterScreen} />
      <Stack.Screen name="ForgotMPIN" component={ForgotMPINScreen} />
      <Stack.Screen name="VersionDetails" component={VersionDetailsScreen} />
    </Stack.Navigator>
  );
}
